import { Cookie } from "src/constants/Cookie";
import { cookie } from "./Cookie";

const apiRequest = async (url: string, params: Record<string, any> = {}) => {
    const urlParams = new URLSearchParams(params);
    const token = cookie.get(Cookie.TOKEN);
    const urlWithParams = `${url}?${urlParams}`;
    const response = await fetch(urlWithParams, { headers: { "Authorization": token } });
    if (response.status === 401) {
        cookie.remove(Cookie.TOKEN);
        alert("Your session has expired. Please refresh the page to continue.");
    }
    return response;
}

export default apiRequest;